module.exports = __webpack_public_path__ + "img/clube4.c5589ad6.jpeg";